// extracted by mini-css-extract-plugin
module.exports = {"stylesButton":"jd2CdFnc","stylesXsButton":"C8Wo2Ajr"};